import React from 'react';
import { withRouter } from 'react-router-dom';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import RespondentEdit from './RespondentEdit';
import RespondentEditQuery from './RespondentEditQuery';

const UPDATE_RESPONDENT = gql`
  mutation updateRespondent($input: UpdateRespondentDetailsInput!) {
    updateRespondentDetails(input: $input) {
      respondent {
        id
        email
        firstName
        lastName
        gender
        locale
        type
        targetJob {
          id
          name
        }
        notes
      }
    }
  }
`;


const RespondentEditWithMutation = props => (
  <Mutation mutation={UPDATE_RESPONDENT}>
    {
      updateRespondent => (
        <RespondentEdit
          {...props}
          updateRespondent={updateRespondent}
        />
      )
    }
  </Mutation>
);

export default withRouter(RespondentEditQuery(RespondentEditWithMutation));
